/*var contact_area_desk = document.querySelector(".desk-contact");
if (contact_area_desk != null){
  var sticky_bottom_1 = contact_area_desk.offsetTop - contact_area_desk.clientHeight;
}

function myFunction(){
  if (window.pageYOffset > sticky_bottom_1){
    contact_area_desk.classList.add("border-black");
    console.log('contact_area');
  } else {
    contact_area_desk.classList.remove("border-black");
  }
}

var abt_str_area = document.querySelector(".abt-str-open-hrs");
if (abt_str_area != null){
  var sticky_abt_str = abt_str_area.offsetTop - abt_str_area.clientHeight;
}

function open_hours(){
  if (window.pageYOffset > sticky_abt_str){
    abt_str_area.classList.add("border-black");
  } else {
    abt_str_area.classList.remove("border-black");
  }
}

var map_area = document.querySelectorAll(".gmap-area--abt-page-parents")[1];
if (map_area != null){
  var sticky_bottoms = map_area.offsetTop - map_area.clientHeight;
}

function map_function(){
  if (window.pageYOffset > sticky_bottoms){
    map_area.classList.add("border-black");
  } else {
    map_area.classList.remove("border-black");
  }
}
window.onscroll = function() {
  if (contact_area_desk != null){
    myFunction()
  }
  if (abt_str_area != null){
    open_hours()
  }
  if (map_area != null){
    map_function()
  }
  
};*/

// Swiper Configuration
var swiper = new Swiper(".about-slider", {
  slidesPerView: "auto",
  loop: true,
  pagination: {
    el: ".swiper-pagination-mobile",
    clickable: true
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});


function toggleItem(elem) {
  for (var i=0; i<elem.length; i++) {
    elem[i].addEventListener('click', function () {
      var current = this;
      for (var i=0; i<elem.length; i++) {
        if (current != elem[i]) {
          elem[i].classList.remove('active');
        } else if (current.classList.contains('active') === true) {
          current.classList.remove('active');
        } else {
          current.classList.add('active');
        }
      }
    });
  };
}
toggleItem(document.querySelectorAll('.brand-action'));

if (window.screen.width >= 768) {
  window.addEventListener("scroll", function() {
    const header = document.getElementById("header"),
          main_content = document.querySelector('.brand-coll-list-area'),
          scroll = window.pageYOffset | document.body.scrollTop;
    
    if (header != null){
      if (scroll > 1) {
        header.className = "brand-border-bottom sticky";
        main_content.className = 'brand-coll-list-area spacing-top-sticky';
      } else if (scroll <= 1) {
        header.className = "brand-border-bottom"; 
        main_content.className = 'brand-coll-list-area';
      }
    }
  });

  var btn_label = document.querySelectorAll('.disbled-desktop-btn');
  for (var i = 0; i < btn_label.length; i++) {
    btn_label[i].href = "javascript:void(0)";
  }
}

document.querySelectorAll('.anchor-stikcy').forEach(function(sticky_block){
  sticky_block.addEventListener('click', function(e) {
    e.preventDefault();
    var a_herf_val = sticky_block.getAttribute("href");
    var $yoyo = a_herf_val.substring(1);
    var Top = document.getElementById($yoyo).offsetTop;
    var offsetTop = document.documentElement.scrollTop = Top - 80;
    
    scroll({
      top: offsetTop,
      behavior: "smooth"
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.brand-label').forEach(function(sticky_block){
      sticky_block.addEventListener('click', function(e) {
          e.preventDefault();
          var fullHref = sticky_block.getAttribute("href");
          var hashIndex = fullHref.lastIndexOf('#');
          var elementId = hashIndex > -1 ? fullHref.substring(hashIndex + 1) : '';

          if(elementId) {
              var element = document.getElementById(elementId);
              if(element) {
                  var Top = element.offsetTop;
                  var offsetTop;

                  if (window.screen.width >= 992) {
                      offsetTop = document.documentElement.scrollTop = Top - 124;
                  } else if (window.screen.width >= 768) {
                      offsetTop = document.documentElement.scrollTop = Top - 220;
                  } else {
                      offsetTop = document.documentElement.scrollTop = Top - 62;
                  }

                  window.scrollTo({
                      top: offsetTop,
                      behavior: "smooth"
                  });
              } else {
                  console.error('Element not found: ' + elementId);
              }
          } else {
              console.error('No hash found in href: ' + fullHref);
          }
      });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq-category').forEach(function(sticky_block){
      sticky_block.addEventListener('click', function(e) {
          e.preventDefault();
          var fullHref = sticky_block.getAttribute("href");
          var hashIndex = fullHref.lastIndexOf('#');
          var elementId = hashIndex > -1 ? fullHref.substring(hashIndex + 1) : '';

          if(elementId) {
              var element = document.getElementById(elementId);
              if(element) {
                  var Top = element.offsetTop;
                  var offsetTop = document.documentElement.scrollTop = Top + 140;

                  window.scrollTo({
                      top: offsetTop,
                      behavior: "smooth"
                  });
              } else {
                  console.error('Element not found: ' + elementId);
              }
          } else {
              console.error('No hash found in href: ' + fullHref);
          }
      });
  });
});

if(window.innerWidth > 575){
document.querySelectorAll('.header-account').forEach(function(accButton){
  accButton.addEventListener('click',function(e){
    document.querySelector('body').classList.add('open-ac-drawer');
    document.querySelector('body').classList.remove('open-menu','open-drawer','open-search','open-sort','open-filter');
  });
});
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
        if (isNotCombinedKey) {
          if(document.querySelector("body.open-ac-drawer")){
            document.querySelector("body.open-ac-drawer").classList.remove("open-ac-drawer");
          }
        }
    }
});

function swymCallbackFn() {
  window._swat.fetch( function(r) {
    if( document.querySelector(".th_wlc_position_relative") != null){
      if(r.length>0){
        document.querySelector(".th_wlc_position_relative").classList.add("active");
        // $('.favorite-header').addClass('active');
        }else{
        document.querySelector(".th_wlc_position_relative").classList.remove("active");
        // $('.favorite-header').removeClass('active');
      }
    }
  });
}


if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

